(function () {
  function jsonEndpoint(url) {
    if (!url) return '';
    return url.endsWith('.js') ? url : url + '.js';
  }

  function setCheckoutDisabled(disabled) {
    document.querySelectorAll('button[name="checkout"]').forEach(function (button) {
      button.disabled = disabled;
    });
  }

  async function changeProtection(root, shouldAdd, silent) {
    if (!root || root.dataset.busy === 'true') return;

    var variantId = Number(root.dataset.variantId || 0);
    var lineKey = root.dataset.lineKey || '';
    var present = root.dataset.present === 'true';
    var error = root.querySelector('[data-hollora-protection-error]');
    var toggle = root.querySelector('[data-hollora-protection-toggle]');

    if (!variantId) return;

    root.dataset.busy = 'true';
    root.classList.add('is-loading');
    if (toggle) toggle.disabled = true;
    if (error) error.hidden = true;
    setCheckoutDisabled(true);

    try {
      var response;
      if (shouldAdd && !present) {
        response = await fetch(jsonEndpoint(window.routes && window.routes.cart_add_url), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      } else {
        response = await fetch(jsonEndpoint(window.routes && window.routes.cart_change_url), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lineKey || variantId, quantity: shouldAdd ? 1 : 0 })
        });
      }

      if (!response || !response.ok) throw new Error('Cart update failed');
      window.location.reload();
    } catch (err) {
      root.dataset.busy = 'false';
      root.classList.remove('is-loading');
      if (toggle) {
        toggle.checked = present;
        toggle.disabled = false;
      }
      if (error && !silent) error.hidden = false;
      setCheckoutDisabled(false);
    }
  }

  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-hollora-protection-toggle]');
    if (!toggle) return;
    var root = toggle.closest('[data-hollora-protection]');
    changeProtection(root, toggle.checked, false);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-hollora-protection]').forEach(function (root) {
      var present = root.dataset.present === 'true';
      var regularCount = Number(root.dataset.regularCount || 0);
      var quantity = Number(root.dataset.quantity || 0);

      if (present && regularCount === 0) {
        changeProtection(root, false, true);
      } else if (present && quantity > 1) {
        changeProtection(root, true, true);
      }
    });
  });
})();
